import { render, staticRenderFns } from "./FormRow.vue?vue&type=template&id=f1013936&scoped=true&"
import script from "./FormRow.vue?vue&type=script&lang=js&"
export * from "./FormRow.vue?vue&type=script&lang=js&"
import style0 from "./FormRow.vue?vue&type=style&index=0&id=f1013936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1013936",
  null
  
)

export default component.exports